import type { ProposalDetail } from '../../types/agent';

export function ConversationPanel({ p }: { p: ProposalDetail }) {
  return (
    <section className="border border-neutral-300 dark:border-neutral-700 p-4">
      <h3 className="font-semibold mb-2">Conversation</h3>
      <div className="space-y-2 max-h-[60vh] overflow-y-auto pr-1">
        {p.transcript.map((m, i) => (
          <div
            key={i}
            className={`flex ${m.role === 'agent' ? 'justify-start' : 'justify-end'}`}
          >
            <div
              className={
                m.role === 'agent'
                  ? 'bg-neutral-100 text-neutral-900 dark:bg-neutral-700 dark:text-neutral-100 p-2 max-w-[75%]'
                  : 'bg-neutral-800 text-white dark:bg-neutral-100 dark:text-neutral-900 p-2 max-w-[75%]'
              }
            >
              <div className="text-xs opacity-70 mb-1">{m.role}</div>
              <div className="text-sm">{m.content}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
